var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle, _path8, _path9, _path0, _ellipse, _circle2, _path1, _path10, _ellipse2, _circle3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRektNewbieBadge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 750 749.4",
    style: {
      enableBackground: "new 0 0 750 749.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#42ADE2;}\n\t.st1{fill:#FED0AC;}\n\t.st2{fill:#F5F5F5;}\n\t.st3{fill:#574137;}\n\t.st4{fill:#FFFFFF;}\n\t.st5{fill:#FF717F;}\n\t.st6{fill:#CF4350;}\n\t.st7{fill:#FF5263;}\n\t.st8{fill:#3E4347;}\n\t.st9{fill:#0A84A5;}\n\t.st10{fill:#231F20;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M750,315c0-37.5-18.8-70-48.8-88.8c3.8-11.2,6.2-23.7,6.2-36.2c0-58.8-46.2-107.5-103.8-108.8 C587.5,50,555,27.5,517.5,27.5c-18.7,0-36.2,5-51.2,15C447.5,17.5,413.7,0,375,0s-72.5,17.5-92.5,42.5c-15-10-32.5-15-51.2-15 c-37.5,0-70,21.2-86.2,53.8C87.5,82.5,41.3,130,41.3,190c0,12.5,2.5,25,6.2,36.2C18.8,245,0,277.5,0,315c0,25,8.8,48.8,23.8,67.5 c-6.2,12.5-10,26.2-10,41.2c0,33.8,18.8,63.7,46.2,78.7c0,3.8-1.2,6.2-1.2,10c0,48.8,38.7,88.8,86.2,88.8h458.8 c47.5,0,86.2-40,86.2-88.8v-10c27.5-15,46.2-45,46.2-78.7c0-15-3.8-28.8-10-41.2C741.3,363.8,750,341.3,750,315"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M622.5,412.5c-1.2,11.3-3.8,22.5-7.5,28.8c-6.2,11.2-17.5,17.5-17.5,17.5s3.8-11.2,2.5-42.5 c-16.2-248.8-46.2-137.5-223.8-137.5S168.7,167.5,152.5,416.2c-1.2,31.2,2.5,42.5,2.5,42.5s-11.2-6.2-17.5-17.5 c-3.8-6.2-5-16.2-7.5-28.8c-18.8-5-43.8-1.2-43.8,53.8c0,33.8,12.5,62.5,55,65c17.5,137.5,71.3,160,178.7,208.8 c28.8,12.5,86.3,12.5,113.8,0c107.5-48.8,161.3-71.2,178.7-208.8c42.5-2.5,55-31.2,55-65C665,411.2,641.2,407.5,622.5,412.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M588.8,418.8C572.5,178.7,545,295,375,295S177.5,178.7,161.2,418.8c-1.2,30,5,83.8,8.8,111.2 c10,65,48.8,152.5,150,200c27.5,12.5,82.5,12.5,108.8,0c102.5-46.2,141.2-135,150-200C583.8,501.3,590,447.5,588.8,418.8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M490,591.2c-47.5,48.8-41.2,110-115,110s-67.5-61.3-115-110c-46.3-48.8,63.8,6.2,115,6.2S536.2,542.5,490,591.2 "
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M461.3,577.5l-86.3,20l-86.2-20c0,0-2.5,20,6.2,28.8c12.5,12.5,60,18.8,81.2,18.8c21.3,0,67.5-6.2,81.2-18.8 C463.7,598.8,461.2,577.5,461.3,577.5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M375,663.8c-35,0-46.2,25-46.2,25l46.2,7.5l46.2-7.5C421.2,688.8,410,663.8,375,663.8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M375,587.5c-28.8,0-197.5-62.5-123.8,7.5c40,37.5,40,125,123.8,125s83.8-86.3,123.8-125 C572.5,525,403.8,587.5,375,587.5 M473.8,601.2c-41.2,41.2-35,91.2-98.8,92.5c-63.8,0-57.5-51.2-98.8-92.5c-40-40,55,5,98.8,5 S513.8,560,473.8,601.2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 375,
    cy: 517.5,
    r: 82.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M312.5,422.5c0,36.2-100,36.2-100,0C212.5,298.8,312.5,298.8,312.5,422.5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M321.2,427.5c0,46.3-125,46.3-125,0C196.3,273.8,321.2,273.8,321.2,427.5"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M317.5,428.8c0,36.2-100,36.2-100,0C217.5,305,317.5,305,317.5,428.8"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st9",
    cx: 271.2,
    cy: 406.2,
    rx: 31.2,
    ry: 43.8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 271.2,
    cy: 406.2,
    r: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M428.8,427.5c0,46.3,125,46.3,125,0C553.8,273.8,428.8,273.8,428.8,427.5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M432.5,428.8c0,36.2,100,36.2,100,0C532.5,305,432.5,305,432.5,428.8"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st9",
    cx: 478.8,
    cy: 406.2,
    rx: 31.2,
    ry: 43.8
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 478.8,
    cy: 406.2,
    r: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRektNewbieBadge);
export default __webpack_public_path__ + "static/media/rekt_newbie_badge.350d4064478c63fdcdd7293259697831.svg";
export { ForwardRef as ReactComponent };